import { render } from "./ProjectMemberEditor.vue?vue&type=template&id=38bf3e06&scoped=true"
import script from "./ProjectMemberEditor.vue?vue&type=script&lang=js"
export * from "./ProjectMemberEditor.vue?vue&type=script&lang=js"

import "./ProjectMemberEditor.vue?vue&type=style&index=0&id=38bf3e06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bf3e06"]])

export default __exports__